
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("hmhfR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $ca31e0301f32f6a5$var$_jquery = $ca31e0301f32f6a5$var$_interopRequireDefault((parcelRequire("jG4hL")));
function $ca31e0301f32f6a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $ca31e0301f32f6a5$var$init = module.exports.init = function init() {
    var timeOutFunctionId;
    (0, $ca31e0301f32f6a5$var$_jquery["default"])(".flyout-row").each(function(e) {
        (0, $ca31e0301f32f6a5$var$_jquery["default"])(this).addClass("cols-" + (0, $ca31e0301f32f6a5$var$_jquery["default"])(this).find(".flyout-col").length);
    });
    (0, $ca31e0301f32f6a5$var$_jquery["default"])(".boilerplate").last().parents(".flyout-section").addClass("last");
    (0, $ca31e0301f32f6a5$var$_jquery["default"])(".header-top-row .topmenu").clone().prependTo(".flyout-section.last > .container");
    (0, $ca31e0301f32f6a5$var$_jquery["default"])("#flyout-menu-rebrush").on("click", function(e) {
        var $fNavBtn = (0, $ca31e0301f32f6a5$var$_jquery["default"])("#flyout-menu-rebrush");
        var $fNav = (0, $ca31e0301f32f6a5$var$_jquery["default"])(".big-nav");
        if ($fNavBtn.hasClass("open")) {
            $fNavBtn.removeClass("open");
            $fNav.slideUp();
        } else {
            $fNavBtn.addClass("open");
            $fNav.slideDown();
        }
    });
    (0, $ca31e0301f32f6a5$var$_jquery["default"])(window).on("resize", function(e) {
        clearTimeout(timeOutFunctionId);
        timeOutFunctionId = setTimeout(function() {
            if ((0, $ca31e0301f32f6a5$var$_jquery["default"])(window).width() > 992) (0, $ca31e0301f32f6a5$var$_jquery["default"])(".big-nav").attr("style", "");
        }, 100);
    });
    (0, $ca31e0301f32f6a5$var$_jquery["default"])(".flyout-navigation .navbar-nav .flyout-links .header").on("click", function(e) {
        var $fLinks = (0, $ca31e0301f32f6a5$var$_jquery["default"])(e.target).parents(".flyout-links");
        if ($fLinks.hasClass("open")) {
            $fLinks.removeClass("open");
            $fLinks.find("ul").slideUp();
        } else {
            (0, $ca31e0301f32f6a5$var$_jquery["default"])(".flyout-links.open").find("ul").slideUp();
            (0, $ca31e0301f32f6a5$var$_jquery["default"])(".flyout-links.open").removeClass("open");
            $fLinks.addClass("open");
            $fLinks.find("ul").slideDown();
        }
    });
    (0, $ca31e0301f32f6a5$var$_jquery["default"])(".flyout-container a").attr("tabindex", "-1");
    var showBigMenu = function showBigMenu($this) {
        (0, $ca31e0301f32f6a5$var$_jquery["default"])(".nav-link").removeClass("show");
        (0, $ca31e0301f32f6a5$var$_jquery["default"])(".nav-item .flyout-container a").attr("tabindex", "-1");
        $this.addClass("show");
        $this.parents(".nav-item").find(".flyout-container a").attr("tabindex", "0");
    };
    var hideBigMenu = function hideBigMenu($this) {
        (0, $ca31e0301f32f6a5$var$_jquery["default"])(".nav-link").removeClass("show");
        $this.parents(".nav-item").find(".flyout-container a").attr("tabindex", "-1");
    };
    // $(".nav-link").on("click", function (e) {
    //   e.preventDefault();
    //   let $this = $(this);
    //   $this.hasClass("show") ? hideBigMenu($this) : showBigMenu($this);
    // });
    (0, $ca31e0301f32f6a5$var$_jquery["default"])(".big-nav .nav-link").on("mouseenter", function(e) {
        var $this = (0, $ca31e0301f32f6a5$var$_jquery["default"])(e.target);
        showBigMenu($this);
    });
    (0, $ca31e0301f32f6a5$var$_jquery["default"])(".big-nav .nav-link").on("mouseleave", function(e) {
        var $this = (0, $ca31e0301f32f6a5$var$_jquery["default"])(e.target);
        hideBigMenu($this);
    });
};

});


//# sourceMappingURL=flyoutMenuRebrush.module.daac971b.js.map
